import React, { Fragment, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { DateLayerPopup, openLayerFn } from "../../Layout";
import DateInput from "./DateInput";
import { IC } from "../../../resources/Assets";
import { AppContext } from "../../../components/AppProvider";
import { PostApi1954 } from "../../../modules/network/padoPost";
import { AlertLayer } from "../../../components/UI/Dialog";
import useTitle from "../../../modules/hooks/useTitle";

export default props => {
  const { userinfo, cfg } = useContext(AppContext);
  useTitle("자가건강관리_검사결과_입력");

  let toDay = new Date();
  let toYear = toDay.getFullYear().toString();
  let toMonthData = toDay.getMonth() + 1;
  let toDateData = toDay.getDate();

  const [dateTarget, setDateTarget] = useState("FROM");
  const [isDisplay, setIsDisplay] = useState(false);
  const [srchFrDt, setSrchFrDt] = useState(
    toYear + toMonthData.toString() + toDateData.toString()
  );

  if (toMonthData < 10) {
    toMonthData = "0" + toMonthData.toString();
  }
  if (toDateData < 10) {
    toDateData = "0" + toDateData.toString();
  }

  const settingSearchFromDate = date => {
    if (dateTarget === "FROM") {
      props.setStartDate(date);
    }

    setIsDisplay(false);
  };

  const openTargetLayer = () => {
    openLayerFn($(".bloodgoal-layer"));
  };

  const getTargetStudyResult = studItemCd => {
    PostApi1954(userinfo, cfg, studItemCd)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          props.setTargetStudyResult(res.result.studRslt);
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    getTargetStudyResult("hba1c");
  }, []);

  return (
    <Fragment>
      <SectionDiv style={{ paddingTop: "44px" }}>
        <SectionTitle>
          목표당화혈색소
          <p
            style={{
              float: "right",
              fontSize: "12px",
              fontWeight: "500",
              marginRight: "22px",
            }}
            onClick={() => openTargetLayer()}>
            목표당화혈색소 설정
          </p>
          <i
            style={{
              backgroundImage: "url(" + IC.etc.IC_SETTING_GREY + ")",
              backgroundRepeat: "round",
              width: "16px",
              height: "16px",
              position: "absolute",
              right: "16px",
            }}
          />
        </SectionTitle>

        <div className="full-input">
          <div className="inp-with-unit">
            <div>
              {/* 목표 당화혈색소 컴포넌트 */}
              <div
                style={{
                  border: "1px solid #d0d0d0",
                  borderRadius: "7px",
                  height: "42px",
                  padding: "6px 13px",
                  boxShadow: "0px 5px #e1e1e1",
                  display: "flex",
                  alignItems: "center",
                }}>
                <i
                  style={{
                    backgroundImage: "url(" + IC.etc.IC_BLOOD + ")",
                    backgroundRepeat: "round",
                    width: "24px",
                    height: "24px",
                    position: "static",
                    marginRight: "10px",
                  }}
                />
                조절목표
                <p
                  style={{
                    fontSize: "28px",
                    fontWeight: "700",
                    color: "#7fd2c2",
                    marginLeft: "16px",
                  }}>
                  {props.targetStudyResult
                    ? props.targetStudyResult + "%"
                    : "6.5% 미만"}
                </p>
              </div>
              {/* 목표 당화혈색소 컴포넌트 */}
            </div>
          </div>
          {/* <p style={{ paddingTop: "10px", color: "#56a6fd" }}>
                        표준 당화혈색소는 4.0~6.0%를 정상으로 분류합니다.
                    </p> */}
        </div>
      </SectionDiv>

      <SectionDiv>
        <SectionTitle>검사일</SectionTitle>

        <div className="full-input">
          <div className="inp-with-unit">
            <div>
              <DateInput
                setIsDisplay={setIsDisplay}
                setDateTarget={settingSearchFromDate}
                srchFrDt={props.startDate}
              />
            </div>
          </div>
        </div>
      </SectionDiv>

      <SectionDiv>
        {props.inputTitle.map((m, i) => (
          // <ListDiv key={"inputTarget" + i}>
          //   <NameDiv id={m.code + "Name"}>{m.name}</NameDiv>
          //   <InputData type="number" id={m.code + "Value"} name={"postData"} />
          //   <PercentI>%</PercentI>
          // </ListDiv>

          <InputDiv
            key={"inputTarget" + i}
            divId={m.code + "Name"}
            divText={m.name}
            inputId={m.code + "Value"}
          />
        ))}
      </SectionDiv>
      {isDisplay && (
        <DateLayerPopup
          isDisplay={isDisplay}
          setIsDisplay={setIsDisplay}
          settingSearchFromDate={settingSearchFromDate}
          startDate={props.startDate}
          color={"green"}
        />
      )}
    </Fragment>
  );
};

export const InputDiv = (props) => {
    return (
        <ListDiv>
            <NameDiv id={props.divId}>{props.divText}</NameDiv>
            <InputData
                type="number"
                // pattern="\d*"
                inputMode="decimal"
                id={props.inputId}
                name={"postData"}
                onChange={(e) => maxLengthCheck(e, 4)}
            />
            <PercentI>%</PercentI>
        </ListDiv>
    );
};

const SectionDiv = styled.div`
  padding-top: 32px;
  padding-left: 16px;
  padding-right: 16px;
`;

const SectionTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
`;

const ListDiv = styled.div`
  padding-bottom: 16px;
  position: relative;
  display: flex;
`;

// float:left;
const NameDiv = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 36px;
`;

// float:right;
const InputData = styled.input`
  border: 1px solid #d0d0d0;
  border-radius: 7px;
  background: #fff;
  box-sizing: border-box;
  height: 40px;
  position: absolute;
  right: 0px;
  padding-right: 32px;
  padding-left: 16px;
  width: 70%;
`;

const PercentI = styled.i`
  right: 16px;
  font-size: 16px;
  color: #999;
  position: absolute;
  line-height: 40px;
`;
